import React from 'react';
import { Link } from 'react-scroll';
import ContactScrollLink from './contact/ContactScrollLink';
import './DevelopmentPartnership.css';

function DevelopmentPartnership() {
    return (
        <section id="pozemky-a-investice" className="development-partnership" aria-labelledby="development-title">
            <div className="container">
                <div className="development-heading">
                    <span className="development-eyebrow">Spolupráce na dalších projektech</span>
                    <h2 id="development-title">Hledám partnery pro menší developerské projekty</h2>
                    <p>
                        Po dokončení projektu Kubelíkova připravuji další podobné záměry. Rád se spojím
                        s vlastníky stavebních pozemků i s jednotlivci nebo skupinami investorů, kteří
                        chtějí společně připravit a realizovat menší developerský projekt.
                    </p>
                </div>

                <div className="development-cards">
                    <article className="development-card">
                        <h3>Máte stavební pozemek?</h3>
                        <p>
                            Projdeme jeho možnosti využití, podmínky výstavby a varianty spolupráce.
                            Vedle prodeje může dávat smysl i společná realizace menšího projektu.
                        </p>
                        <ContactScrollLink className="development-card-link" subject="Nabídka pozemku">
                            Probrat můj pozemek
                        </ContactScrollLink>
                    </article>
                    <article className="development-card">
                        <h3>Zvažujete investici do výstavby?</h3>
                        <p>
                            Mohu zajistit přípravu záměru, koordinaci potřebných kroků a realizaci stavby.
                            Role, kontrolu nad projektem i nakládání s prostředky nastavíme společně
                            předem podle konkrétní dohody.
                        </p>
                        <ContactScrollLink className="development-card-link" subject="Investiční spolupráce">
                            Probrat investiční spolupráci
                        </ContactScrollLink>
                    </article>
                </div>

                <Link className="development-reference" to="projekt-kubelikova" smooth={true} offset={-80}>
                    Podívat se na dokončený projekt Kubelíkova
                </Link>
            </div>
        </section>
    );
}

export default DevelopmentPartnership;
